import { Grid } from '@mui/material';
import { Controller, UseFormReturn } from 'react-hook-form';
import { Label, WsButtonGroup, WsInputNumber, WsTypography, WsTypoVariants } from 'wisestep-base';

import { ContractFormType } from './ContractRevenueCalculator';
export interface ContractRevenueCalculatorForm {
  methods: UseFormReturn<ContractFormType>;
  editable?: boolean;
}
enum formOptions {
  STANDARD_HOURS = 'standardHours',
  STANDARD_DAYS = 'standardDays',
  STANDARD_MONTHS = 'standardMonths',
  OVERRIDE_STANDARD_LESS = 'overrideStandardLess',
  OVERRIDE_STANDARD_MORE = 'overrideStandardMore',
}
interface formParameters {
  name: formOptions;
  label: string;
}
const ContractRevenueCalculatorForm = ({
  editable = true,
  methods,
}: ContractRevenueCalculatorForm) => {
  const calenderData: formParameters[] = [
    { name: formOptions.STANDARD_HOURS, label: 'Standard Contract Hours (Per Day)' },
    { name: formOptions.STANDARD_DAYS, label: 'Standard Contract Days (Per Month)' },
    { name: formOptions.STANDARD_MONTHS, label: 'Standard Contract Months' },
  ];
  const tenureValidatation: formParameters[] = [
    {
      name: formOptions.OVERRIDE_STANDARD_LESS,
      label: 'Tenure for Individual Job is less',
    },
    {
      name: formOptions.OVERRIDE_STANDARD_MORE,
      label: 'Tenure for Individual Job is More',
    },
  ];
  return (
    <Grid container rowSpacing={4} pl={5} py={2}>
      {calenderData.map((data, index) => (
        <Grid key={index} item container>
          <Grid item xs={6}>
            <Label>{data.label}</Label>
          </Grid>
          <Grid item xs={4}>
            <WsInputNumber name={data.name} disabled={!editable} />
          </Grid>
        </Grid>
      ))}
      <Grid item>
        <WsTypography variant={WsTypoVariants.TITLE} bold>
          Tenure Overrides - Standard Months If,
        </WsTypography>
      </Grid>
      {tenureValidatation.map((data, index) => (
        <Grid key={index} item container>
          <Grid item xs={6}>
            <Label>{data.label}</Label>
          </Grid>
          <Grid item xs={4}>
            <Controller
              name={data.name}
              control={methods.control}
              render={({ field }) => (
                <WsButtonGroup
                  inputTitle=""
                  hideInputTitle={true}
                  disabled={!editable}
                  buttonsList={['YES', 'NO']}
                  defaultValue={field.value ? 0 : 1}
                  selectedIndexValue={(pos) => field.onChange(pos === 0)}
                />
              )}
            />
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
};
export default ContractRevenueCalculatorForm;
